import { createFileRoute } from '@tanstack/react-router';
import { SessionDetails } from '@/components/SessionDetails';

export const Route = createFileRoute('/sessions/$sessionId')({
  component: SessionDetails,
});